<div class="row my-3">
  <div class="col-8 offset-2">
    <h2 class="mb-5">Dostop za izvajalce</h2>
  </div>
  <div class="col-4 offset-2 border-right">
    <h3>Še nimate dostopa?</h3>

    <p>Premium profil je namenjen vsem zdravstvenim izvajalcem, ki želite razširiti svoj domet in izpostaviti svoje
      storitve obiskovalcem spletnega mesta ČakalneDobe.si.</p>

    <a [href]="premiumFlyerUrl" class="button button-small button-3d button-light m-0"><i
      class="la la-diamond"></i>
      Vse prednosti premium profila
    </a>
  </div>
  <div class="col-4" *ngIf="!forgottenPasswordVisible">
    <h3>Prijava</h3>

    <div class="alert alert-danger" *ngIf="loginError">
      {{loginError}}
    </div>

    <form [formGroup]="loginForm" novalidate (submit)="login(loginForm)">
      <div class="form-group">
        <label for="username">E-naslov</label>
        <input type="text" class="form-control" id="username" formControlName="username">
      </div>
      <div class="form-group">
        <label for="password">Geslo</label>
        <input type="password" class="form-control" id="password" formControlName="password">
      </div>

      <div class="form-group text-right">
        <div class="form-text">
          <a (click)="showForgottenPassword();" style="cursor: pointer">Pozabljeno geslo</a>
        </div>
      </div>

      <div class="form-group text-right">
        <button type="submit" class="button button-3d button-large button-primary mr-0" [disabled]="loginInProgress">
          <i class="la la-sign-in" *ngIf="!loginInProgress"></i>
          <i class="la la-spin la-spinner" *ngIf="loginInProgress"></i>
          Prijava
        </button>
      </div>
    </form>
  </div>

  <div class="col-4 offset-4" *ngIf="forgottenPasswordVisible">
    <h3>Pozabljeno geslo</h3>

    <div class="alert alert-danger" *ngIf="resetError">
      {{resetError}}
    </div>

    <div class="alert alert-success" *ngIf="resetSuccess">
      Zahteva za novo geslo je bila uspešna. Na vaš elektronski naslov, smo vam poslali povezavo, kjer boste lahko
      nastavili novo geslo.<br/><br>
      <a (click)="showForgottenPassword(false);" style="cursor: pointer">Nazaj na prijavo</a>
    </div>

    <form [formGroup]="resetPasswordForm" novalidate (submit)="reset(resetPasswordForm)" *ngIf="!resetSuccess">
      <div class="form-group">
        <label for="email">E-naslov</label>
        <input type="text" class="form-control" id="email" formControlName="username">
      </div>

      <div class="form-group text-right">
        <div class="form-text">
          <a (click)="showForgottenPassword(false);" style="cursor: pointer">Nazaj na prijavo</a>
        </div>
      </div>

      <div class="form-group text-right">
        <button type="submit" class="button button-3d button-large button-primary mr-0" [disabled]="resetProgress">
          <i class="la la-check" *ngIf="!resetProgress"></i>
          <i class="la la-spin la-spinner" *ngIf="resetProgress"></i>
          Potrdi
        </button>
      </div>
    </form>
  </div>
</div>
